import {
  useFinancialDashboard,
  useFinancialCharts,
  useFinancialForecast,
} from '../../../hooks/useFinancial';
import { KpiCards } from '../../../components/financial/KpiCards';
import { HealthIndicators } from '../../../components/financial/HealthIndicators';
import { Charts } from '../../../components/financial/Charts';
import { ForecastChart } from '../../../components/financial/ForecastChart';
import { CustomersTable } from '../../../components/financial/CustomersTable';
import { SyncButton } from '../../../components/financial/SyncButton';
import { LoadingSpinner } from '../../../components/common/LoadingSpinner';
import { EmptyState } from '../../../ui';
import type { Period } from '../../../components/atlas/PeriodSelector';

interface Props {
  period: Period;
}

export function ReceitaTab({ period }: Props) {
  const { data: dashboardData, isLoading: dashLoading } = useFinancialDashboard();
  const { data: chartsData, isLoading: chartsLoading } = useFinancialCharts(period);
  const { data: forecastData } = useFinancialForecast();

  const dashboard = dashboardData?.data;
  const charts = chartsData?.data;
  const forecast = forecastData?.data;

  if (dashLoading) {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    );
  }
  if (!dashboard) {
    return (
      <EmptyState
        title="Sem dados financeiros"
        body="Configure a integração financeira em Configuração."
      />
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-end">
        <SyncButton />
      </div>
      <KpiCards kpis={dashboard.kpis} />
      {chartsLoading ? (
        <div className="flex justify-center py-12">
          <LoadingSpinner />
        </div>
      ) : charts ? (
        <Charts data={charts} />
      ) : null}
      {forecast ? <ForecastChart data={forecast} /> : null}
      <HealthIndicators health={dashboard.health} />
      <CustomersTable />
    </div>
  );
}
